import numeral from "numeral";
import React from "react";
import ReactApexChart from "react-apexcharts";

const BuyerOrderChart = ({ options, series, qtyPieces, value }) => {
    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "48vh", textAlign: "center" }}>


            {/* Chart */}
            <div id="chart">
                <ReactApexChart options={options} series={series} type="pie" width={380} />
            </div>
            {/* Display QTY Pieces & Value */}
            <div style={{ alignSelf: "flex-start", textAlign: "left", marginLeft: "20px" }}>
                <p style={{ fontWeight: "bold", fontSize: "18px", margin: "10px 0" }}>
                    <span style={{ color: "blue" }}>Qty In :</span> <span style={{ color: "black" }}>{qtyPieces} {'PCS'}</span>
                </p>
                <p style={{ fontWeight: "bold", fontSize: "18px", margin: "0px 0" }}>
                    <span style={{ color: "blue" }}>Value:</span> <span style={{ color: "black" }}>{numeral(value).format("0,0.00")}                    </span>
                </p>

            </div>
        </div>
    );
};

export default BuyerOrderChart;

// import React, { useState } from "react";
// import ReactApexChart from "react-apexcharts";

// const BuyerOrderChart = ({ options, series }) => {


//   return (
//     <div>
//       <div id="chart">
//         <ReactApexChart options={options} series={series} type="pie" width={380} />
//       </div>
//       <div id="html-dist"></div>
//     </div>
//   );
// };
// export default BuyerOrderChart;
